import React, { useState, useEffect, useRef } from 'react';
import { TextFieldProps } from '@mui/material';
import KogInputTextUnderline from './inputTextUnderline';

const DEBOUNCE_TIME = 500;

type FilterInputProps = {
  errorMessageCustom?: string | null;
  hasOnlyNumber?: boolean;
  forceShrink?: boolean;
  onDebounce?: (value: string) => void;
} & TextFieldProps;
const KogInputTextFilter = React.forwardRef(
  (
    {
      errorMessageCustom = null,
      hasOnlyNumber = false,
      forceShrink = false,
      onDebounce = () => { },
      ...props
    }: FilterInputProps,
    ref: any
  ) => {
    const [textValue, setTextValue] = useState<string>('');
    const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
      const newValue = event.target.value.toLowerCase();
      setTextValue(newValue);

      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }

      debounceRef.current = setTimeout(() => {
        if (newValue.length > 1 || newValue.length === 0) {
          onDebounce(newValue);
        }
      }, DEBOUNCE_TIME);
    }

    useEffect(() => {
      return () => {
        if (debounceRef.current) {
          clearTimeout(debounceRef.current);
        }
      };
    }, []);

    return (
      <KogInputTextUnderline
        {...props}
        ref={ref}
        onChange={handleChange}
        value={textValue}
      />
    );
  }
);

export default KogInputTextFilter;